import { SVGProps } from 'react';

export const X = (props: { className?: string } & SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_12_25197)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.2889 19.1668L8.66435 12.5752L2.87503 19.1668H0.425781L7.57772 11.0261L0.425781 0.833496H6.71407L11.0726 7.04601L16.5337 0.833496H18.9829L12.1629 8.59723L19.5772 19.1668H13.2889ZM16.0164 17.3085H14.3674L3.93274 2.69183H5.5819L9.76107 8.54446L10.4838 9.56005L16.0164 17.3085Z"
        fill="currentcolor"
      />
    </g>
    <defs>
      <clipPath id="clip0_12_25197">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
